<template>
  <b-modal
    id="note-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer une note"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selected !== null">
      <div>
        Supprimer la note "{{selected.title}}" ?
      </div>
    </div>
  </b-modal>
</template>

<script>
    import api from '../../services/api';

    export default {

        name: 'NoteDeleteModal',

        props: {
            selected: Object
        },

        emits: ['didDeleteNote'],

        methods: {

            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault() // Prevent modal from closing
                this.handleSubmit()
            },

            handleSubmit() {

                let noteName = this.selected.title

                api
                    .delete(`/note/${this.selected.id}`)
                    .then(response => {
                        this.$emit('didDeleteNote')
                        this.hideModal()
                        this.successToast(`Note \"${noteName}\" supprimée`)
                    })
                    .catch((error) => {
                        if (error.response.status === 418) {
                            this.$bvToast.toast(error.response.data.message, {
                                autoHideDelay: 2000,
                                toaster: 'b-toaster-bottom-right'
                            })
                        }
                    });
            },

            hideModal() {
                this.$bvModal.hide('note-delete-modal')
            },

            successToast(message) {
                this.$bvToast.toast(message, {
                    autoHideDelay: 2000,
                    toaster: 'b-toaster-bottom-right',
                    noCloseButton: true
                })
            }
        }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/note/NoteDeleteModal.vue